import { Header } from "build-ts/metadata";
import React, { useState } from "react";
import MKGNodeMenuComponent from "components/configuration/MKGNodeMenuComponent";
import { useEffect } from "react";
import { MetadataTypeEnum } from "build-ts/enums";
import { useConfigurationContext } from "context/ConfigurationContext";
import { useDisclosure } from "@chakra-ui/react";
import showToast from "hooks/useCustomToast";
import { deleteBenchmark } from "services/MetricService";

interface MKGNodeMenuContainerProps {
  isClicked: boolean;
  selectedMetricHeader?: Header;
}

const MKGNodeMenuContainer: React.FC<MKGNodeMenuContainerProps> = ({
  isClicked,
  selectedMetricHeader,
}) => {
  const [selectedNode, setSelectedNode] = useState<Header | null>(selectedMetricHeader || null);
  const [nodeType, setNodeType] = useState<MetadataTypeEnum>(MetadataTypeEnum.METRIC);
  const [openEditMetricDefinition, setOpenEditMetricDefinition] = useState(false);
  const [openEditMKG, setOpenEditMKG] = useState(false);
  const [openViewMKG, setOpenViewMKG] = useState(false);
  const [openEditBenchmark, setOpenEditBenchmark] = useState(false);
  const [openEditKgColumn, setOpenEditKgColumn] = useState(false);
  const [openDeleteMetric, setOpenDeleteMetric] = useState(false);
  const [openDeleteBenchmark, setOpenDeleteBenchmark] = useState(false);
  const [openDeleteKgColumn, setOpenDeleteKgColumn] = useState(false);
  const [openDeleteMetricDialog, setOpenDeleteMetricDialog] = useState(false);
  const [openDeleteBenchmarkDialog, setOpenDeleteBenchmarkDialog] = useState(false);
  const [openDeleteKgColumnDialog, setOpenDeleteKgColumnDialog] = useState(false);

  const {isOpen, onOpen, onClose} = useDisclosure();

  const {
    setSelectedMetric,
    fetchBenchmarkById, 
    setSelectedBenchmark, 
    setSelectedKgColumn, 
    updateMetric,
    deleteMetricById,
    deleteKgColumnById,
    setDependencies,
  } = useConfigurationContext();

  // handle edit metric definition modal
  const handleEditMetricDefinitionModal = (metricHeader: Header) => {
    setSelectedMetric(metricHeader);
    setOpenEditMetricDefinition(true);
    setOpenEditMKG(false);
    setOpenEditBenchmark(false);
    setOpenEditKgColumn(false);
    onOpen();
  };

  // handle edit mkg modal
  const handleEditMKGModal = (metricHeader: Header, modelId: string) => {
    updateMetric(metricHeader, modelId);
    setSelectedMetric(metricHeader);
    setOpenEditMetricDefinition(false);
    setOpenEditMKG(true);
    setOpenEditBenchmark(false);
    setOpenEditKgColumn(false);
    onOpen();
  };

  // handle view mkg modal
  const handleViewMKGModal = (metricHeader: Header) => {
    setSelectedMetric(metricHeader);
    setOpenViewMKG(true);
    onOpen();
  };

  // handle delete metric alert-dialog box
  const handleDeleteMetricDialog = (id: string) => {
    setOpenDeleteMetricDialog(true);
  };

  // close delete metric alert-dialog box
  const closeDeleteMetricDialog = () => {
    setOpenDeleteMetricDialog(false);
  };

  const closeDeleteMetric = () => {
    setOpenDeleteMetric(false);
  };

  // handle delete metric
  const handleDeleteMetric = (id: string) => {
    closeDeleteMetricDialog();
    deleteMetricById(id);
    setOpenDeleteMetric(true);
  };

  // handle edit benchmark modal
  const handleEditBenchmarkModal = (benchmarkHeader: Header) => {
    setSelectedBenchmark(benchmarkHeader);
    setOpenEditBenchmark(true);
    fetchBenchmarkById(benchmarkHeader.id!);
    setOpenEditMetricDefinition(false);
    setOpenEditMKG(false);
    setOpenEditKgColumn(false);
    onOpen();
  };

  // handle delete benchmark alert-dialog box
  const handleDeleteBenchmarkDialog = (id: string) => {
    //setDeleteBenchmarkId(id);
    setOpenDeleteBenchmarkDialog(true);
  };

  // close delete benchmark alert-dialog box
  const closeDeleteBenchmarkDialog = () => {
    setOpenDeleteBenchmarkDialog(false);
  };

  const deleteBenchmarkById = async (id: string) => {
    const response: any = await deleteBenchmark(id);
    if(response) {
      setDependencies(response);
      setOpenDeleteBenchmark(true);
    } else {
      showToast("Benchmark deleted successfully", "", "success");
      window.location.reload();
    }
  };

  // handle delete benchmark
  const handleDeleteBenchmark = (id: string) => {
    closeDeleteBenchmarkDialog();
    deleteBenchmarkById(id);
  };

  // close delete benchmark alert-dialog box
  const closeDeleteBenchmark = () => {
    setOpenDeleteBenchmark(false);
  };

  // handle edit kg column modal
  const handleEditKgColumnModal = (kgColumnHeader: Header) => {
    setSelectedKgColumn(kgColumnHeader);
    setOpenEditKgColumn(true);
    setOpenEditMetricDefinition(false);
    setOpenEditMKG(false);
    setOpenEditBenchmark(false);
    onOpen();
  };

  // handle delete kg column alert-dialog box
  const handleDeleteKgColumnDialog = (id: string) => {
    //setDeleteKgColumnId(id);
    setOpenDeleteKgColumnDialog(true);
  };

  // close delete kg column alert-dialog box
  const closeDeleteKgColumnDialog = () => {
    setOpenDeleteKgColumnDialog(false);
  };

  // close delete kg column
  const closeDeleteKgColumn = () => {
    setOpenDeleteKgColumn(false);
  };

  // handle delete kg column
  const handleDeleteKgColumn = (id: string) => {
    closeDeleteKgColumnDialog();
    console.log("id", id);
    deleteKgColumnById(id);
    setOpenDeleteKgColumn(true);
  };


  // Update selectedMetric when prop changes
  useEffect(() => {
    if (selectedMetricHeader) {
      if(selectedMetricHeader.type === MetadataTypeEnum.METRIC){
        setSelectedNode(selectedMetricHeader);
        setNodeType(MetadataTypeEnum.METRIC);
      }
      else if(selectedMetricHeader.type === MetadataTypeEnum.BENCHMARK){
        setSelectedNode(selectedMetricHeader);
        setNodeType(MetadataTypeEnum.BENCHMARK);
      }
      else if(selectedMetricHeader.type === MetadataTypeEnum.KG_COLUMN){
        setSelectedNode(selectedMetricHeader);
        setNodeType(MetadataTypeEnum.KG_COLUMN);
      }
    }
  }, [selectedMetricHeader]);

  
    return (
    <MKGNodeMenuComponent
      isClicked={isClicked}
      selectedNode={selectedNode!}
      nodeType={nodeType}
      isOpen={isOpen}
      onClose={onClose}

      // Metric
      editMetricDefinition={openEditMetricDefinition}
      editMKG={openEditMKG}
      openViewMKG={openViewMKG}
      handleEditMetricDefinitionModal={handleEditMetricDefinitionModal}
      handleEditMKGModal={handleEditMKGModal}
      handleDeleteMetricDialog={handleDeleteMetricDialog}
      handleViewMKGModal={handleViewMKGModal}
      handleDeleteMetric={handleDeleteMetric}
      closeDeleteMetricDialog={closeDeleteMetricDialog}
      closeDeleteMetric={closeDeleteMetric}
      openDeleteMetric={openDeleteMetric}
      openDeleteMetricDialog={openDeleteMetricDialog}

      // Benchmark
      editBenchmark={openEditBenchmark}
      handleEditBenchmarkModal={handleEditBenchmarkModal}
      handleDeleteBenchmarkDialog={handleDeleteBenchmarkDialog}
      handleDeleteBenchmark={handleDeleteBenchmark}
      closeDeleteBenchmarkDialog={closeDeleteBenchmarkDialog}
      closeDeleteBenchmark={closeDeleteBenchmark}
      openDeleteBenchmark={openDeleteBenchmark}
      openDeleteBenchmarkDialog={openDeleteBenchmarkDialog}

      // KG Column
      editKgColumn={openEditKgColumn}
      handleEditKgColumnModal={handleEditKgColumnModal}
      handleDeleteKgColumnDialog={handleDeleteKgColumnDialog}
      handleDeleteKgColumn={handleDeleteKgColumn}
      closeDeleteKgColumnDialog={closeDeleteKgColumnDialog}
      closeDeleteKgColumn={closeDeleteKgColumn}
      openDeleteKgColumn={openDeleteKgColumn}
      openDeleteKgColumnDialog={openDeleteKgColumnDialog}
    />
  );
};

export default MKGNodeMenuContainer;